import { NgModule } from '@angular/core';


@NgModule({
	declarations: [],
	imports: [],
	exports: []
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts